import Axios from "axios";
import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { MonthlyDaySets } from "../helpers/Chart/utility";

import variables from '../scss/_variables.scss';
import { authHeader } from "../helpers";

export function fetchTmChartData(year, month) {
  const total = [];
  const pending = [];
  const delivered = [];
  const resend = [];
  const failed = [];

  return async dispatch => {
    const dailyReport = await Axios.get(`${process.env.REACT_APP_API_URL}/line-notification/stats?month=${month + 1}&year=${year}`, { headers: authHeader() })

    dispatch({
      type: 'FETCH_TRANS_LOG_EXCEL_DATA',
      payload: dailyReport.data
    })

    MonthlyDaySets(year, month).forEach(v => {
      const data = dailyReport?.data?.find(value => v === value.date?.substring(0, 10));
      total.push(data !== undefined ? data.Total : '0');
      pending.push(data !== undefined ? data.PENDING : '0');
      delivered.push(data !== undefined ? data.DELIVERED : '0');
      resend.push(data !== undefined ? data.Resend : '0');
      failed.push(data !== undefined ? data.FAILED : '0');
    })

    dispatch({
      type: 'FETCH_TRANS_LOG_CHART_DATA',
      payload: {
        labels: MonthlyDaySets(year, month),
        datasets: [
          {
            label: 'Total',
            backgroundColor: variables.medium_blue,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: total,
          },
          {
            label: 'Resend',
            backgroundColor: variables.blue,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: resend,
          },
          {
            label: 'Delivered',
            backgroundColor: variables.green,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: delivered,
          },
          {
            label: 'Failed',
            backgroundColor: variables.coral,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: failed,
          },
          {
            label: 'Pending',
            backgroundColor: variables.gray4,
            borderColor: getStyle('--info'),
            pointHoverBackgroundColor: '#fff',
            borderWidth: 1,
            data: pending,
          },
        ],
      }
    })
  }
}

export function fetchTmReportData(startDate, endDate, event_type) {
  return async dispatch => {
    const durationReport = await Axios.get(
      `${process.env.REACT_APP_API_URL}/line-notification/event/stats?&fromDate=${startDate}&toDate=${endDate}&event_type=${event_type}&excludedEventTypes=ABO_POOL,ME_BUDDY_CHALLENGE`,
      { headers: authHeader() })

    dispatch({
      type: 'FETCH_TRANS_LOG_REPORT_DATA',
      payload: durationReport.data
    })
  }
}

export function fetchEventLogData(pageNo, pageLimit = 50, formData) {
  return async dispatch => {
    const eventReport = await Axios.get(
      `${process.env.REACT_APP_API_URL}/line-notification/events/search?page=${pageNo}&limit=${pageLimit}`,
      { params: formData, headers: authHeader() });
    dispatch({
      type: 'FETCH_TRANS_EVENT_LOG_REPORT_DATA',
      payload: eventReport.data
    })
  }
}